import CHElement from "./CHElement";

class MapMarkerData {
  constructor(
    public lat: number,
    public lon: number,
    public label?: string,
    public info?: CHElement
  ) {}
}

export default MapMarkerData;
